import React from 'react';
import styled from '@emotion/styled';
import { useLocale } from '@devsisters/gatsby-plugin-i18n';
import { useTexts } from '@devsisters/gatsby-plugin-i18n';

import { scaledCss } from '~/src/css';
import { asset } from '~/src/assets';

interface TitleProps {
  className?: string;
}
const Title: React.FC<TitleProps> = ({ className }) => {
  const locale = useLocale();
  const t = useTexts();
  const TitleImg =
    locale === 'en'
      ? TitleImgEn
      : locale === 'ja'
      ? TitleImgJa
      : locale === 'ko'
      ? TitleImgKo
      : locale === 'th'
      ? TitleImgTh
      : locale === 'zh-Hant'
      ? TitleImgZhHant
      : TitleImgKo;
  return (
    <TitleContainer className={className}>
      <TitleImg src={asset(`bravecookies/title/${locale}.png`)} alt={t`$title`} />
    </TitleContainer>
  );
};

export default Title;

const TitleContainer = styled('h1')(
  scaledCss({
    margin: 0,
    height: [250, '250px'],
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  })
);

const createTitleImg = (width: number) =>
  styled('img')(
    scaledCss({
      width: [width, width + 'px'],
    })
  );

const TitleImgEn = createTitleImg(513);
const TitleImgJa = createTitleImg(532);
const TitleImgKo = createTitleImg(492);
const TitleImgTh = createTitleImg(543);
const TitleImgZhHant = createTitleImg(442);
